// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"787":"d0f6b170","845":"ec8615f5"}[chunkId] + ".chunk.js";
};